import React from 'react';
import { Icon } from './Icon.js';
export const IconFolderAnalytics2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M7.5 14.5L10.5 11.5L13.5 14.5L16.5 11.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M2 3V20H22V6H13L10 3H2Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconFolderAnalytics2.js.map